import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Oklahoma = () => {
  return (
    <StatePropertyTaxPage
      stateName="Oklahoma"
      processDescription="Property owners may appeal their assessment by filing with the county board of equalization between July 1 and August 31. Appeals should include evidence supporting the property owner's claimed fair cash value."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in May, giving property owners time to prepare for the summer appeal period."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Oklahoma assesses property as of January 1 each year. This assessment date captures the property's market value and condition at the beginning of each calendar year."
      deadlineExplanation="Property owners must file appeals with the county board of equalization between July 1 and August 31. This two-month window allows adequate time to prepare appeals during the summer months."
    />
  );
};

export default Oklahoma;